// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-item {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column; /* Vertical layout */
  padding: 10px;
  background-color: #222;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  min-width: 300px; /* Set a minimum width to ensure it doesn't shrink */
  max-width: 320px; /* You can adjust this based on the design */
  width: 100%; /* Adjust to ensure flexibility */
  margin-bottom: 16px;
  position: relative; /* Positioning for the edit button */
}
.video-item:hover {
  transform: scale(1.05); /* Enlarge on hover */
}

.edit-button {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  background-color: #ff9900;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.edit-button:hover {
  background-color: #e68a00;
}

.video-thumbnail {
  width: 100%;
  aspect-ratio: 16/9; /* Set a default aspect ratio for landscape videos */
  border-radius: 12px;
  object-fit: contain; /* Ensure the video fits within the container without stretching */
  object-position: center;
  background-color: #000; /* Fallback color to fill empty spaces */
}

.video-thumbnail.portrait {
  aspect-ratio: 9/16; /* Override for portrait videos */
}

.video-timestamp {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.video-details {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding-top: 10px;
}

.video-title {
  margin-bottom: 4px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  line-height: 1.4;
}

.video-info {
  display: flex;
  justify-content: flex-start; /* Keeps the date aligned to the left */
  width: 100%;
  font-size: 14px;
  color: #bbb;
}

.video-info span:last-child {
  margin-left: auto; /* Pushes the duration (last span) to the right */
}

.video-channel {
  color: #bbb;
  font-size: 12px;
}

.video-views {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/VideoBox/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,sCAAA;EACA,aAAA;EACA,sBAAA,EAAA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA,EAAA,oDAAA;EACA,gBAAA,EAAA,4CAAA;EACA,WAAA,EAAA,iCAAA;EACA,mBAAA;EACA,kBAAA,EAAA,oCAAA;AACF;AACE;EACE,sBAAA,EAAA,qBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA,EAAA,oDAAA;EACA,mBAAA;EACA,mBAAA,EAAA,kEAAA;EACA,uBAAA;EACA,sBAAA,EAAA,wCAAA;AAAF;;AAGA;EACE,kBAAA,EAAA,iCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,2BAAA,EAAA,uCAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAAF;;AAGA;EACE,iBAAA,EAAA,iDAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAAF","sourcesContent":[".video-item {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  display: flex;\n  flex-direction: column; /* Vertical layout */\n  padding: 10px;\n  background-color: #222;\n  border-radius: 12px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  min-width: 300px; /* Set a minimum width to ensure it doesn't shrink */\n  max-width: 320px; /* You can adjust this based on the design */\n  width: 100%; /* Adjust to ensure flexibility */\n  margin-bottom: 16px;\n  position: relative; /* Positioning for the edit button */\n  \n  &:hover {\n    transform: scale(1.05); /* Enlarge on hover */\n  }\n}\n\n.edit-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 5px 10px;\n  background-color: #ff9900;\n  border: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.edit-button:hover {\n  background-color: #e68a00;\n}\n\n.video-thumbnail {\n  width: 100%;\n  aspect-ratio: 16 / 9; /* Set a default aspect ratio for landscape videos */\n  border-radius: 12px;\n  object-fit: contain; /* Ensure the video fits within the container without stretching */\n  object-position: center;\n  background-color: #000; /* Fallback color to fill empty spaces */\n}\n\n.video-thumbnail.portrait {\n  aspect-ratio: 9 / 16; /* Override for portrait videos */\n}\n\n.video-timestamp {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 4px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.video-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.video-title {\n  margin-bottom: 4px;\n  font-size: 16px;\n  color: #fff;\n  font-weight: bold;\n  line-height: 1.4;\n}\n\n.video-info {\n  display: flex;\n  justify-content: flex-start; /* Keeps the date aligned to the left */\n  width: 100%;\n  font-size: 14px;\n  color: #bbb;\n}\n\n.video-info span:last-child {\n  margin-left: auto; /* Pushes the duration (last span) to the right */\n}\n\n.video-channel {\n  color: #bbb;\n  font-size: 12px;\n}\n\n.video-views {\n  font-size: 12px;\n  color: #999;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
